import React from "react";

import { useIntl } from "react-intl";

import { Text } from "./style";

const NoData = () => {
  const intl = useIntl();
  return (
    <Text
      x="50%"
      y="50%"
      textAnchor="middle"
      alignmentBaseline="middle"
      fontSize="16"
    >
      {intl.formatMessage({ id: "no_data" })}
    </Text>
  );
};
export default NoData;
//
